module.exports = "/_next/static/images/cancer_BI-a14fab560ac42572212671fea7088d50.png";